import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { MarketplaceBottomBannerComponent } from '../../marketplace/bottom-banner/marketplace-bottom-banner.component';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { AppState } from 'src/app/shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { selectAllCommunityProductCategory } from 'src/app/shareModule/states/community-product-category';
import { BehaviorSubject, takeUntil } from 'rxjs';

@Component({
  selector: 'community-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlesComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  @Input() title: boolean = true;
  @Input() grid: string = '';
  @Input() adminMode: boolean = false;
  @ViewChild('marketplaceBottomBanner') bottomBanner: MarketplaceBottomBannerComponent;
  @ViewChild('AssignOption') AssignModal: MarketplaceBottomBannerComponent;

  public banners: any = {};
  public pageSize = 3;
  public totalPage = [];
  public categoriesList: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedArticle: any = null;
  public commonModal: any = null;
  public imgUrl = environment.ImageUrl;


  constructor(
    private store: Store<AppState>,
    private auth: AuthServiceService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getArticlesList(1, '', '');
    this._getAllMemberShopCategoriesList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getArticlesList(page, memberShopCategory: string, memberShopSubRegion: string) {
    if (this.adminMode || memberShopCategory || memberShopSubRegion) {
      if (this.adminMode) this.pageSize = 15;
      this.auth.getArticlesList(page, 0, 'SG News', this.pageSize, true).subscribe(
        (response: any) => {
          if (response.body && Array.isArray(response.body.data)) {
            this.banners = response.body;
            this.totalPage = response.body.lastPage ? [...Array(response.body.lastPage).keys()] : [];
          }
        }
      );
    } else {
      this.banners.data = [];
    }
  }

  private _getAllMemberShopCategoriesList(): void {
    this.store
      .pipe(select(selectAllCommunityProductCategory))

      .subscribe((list: any) => {
        let response = structuredClone(list);
        let output = response.map(i => {
          let output = i;
          output['checked'] = false;
          return output;
        })
        this.categoriesList = this.commonService.removeDuplicateAndCombineByProp(output, 'name');
      });
  }

  public assign(selectedArticle) {
    this.categoriesList = this.categoriesList.map((i: any) => {
      let output = i;
      output['checked'] = selectedArticle.memberShopCategory ? selectedArticle.memberShopCategory.includes(i.name ? i.name : '') : false;
      return output;
    });
    let selectedId = selectedArticle.memberShopSubRegion ? selectedArticle.memberShopSubRegion.split('|') : [];

    this.subRegionList = structuredClone(this.commonService.subRegionLists.map((j) => {
      let output = JSON.parse(JSON.stringify(j));
      output['checked'] = selectedId.includes(j.subRegionId.toString());
      return output;
    }));

    this.selectedArticle = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' })
  }

  assignArticles() {
    if (this.selectedArticle) {
      let categoryStr = this.categoriesList.filter(i => i.checked).map(i => i.name).join('|');
      let subRegionStr = this.subRegionList.filter(i => i.checked).map(i => i.subRegionId).join('|');
      this.auth.assignArticles({ id: this.selectedArticle.id, memberShopCategory: categoryStr, memberShopSubRegion: subRegionStr }).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this.getArticlesList(1, '', '');
      })
    } else {
      this.toastr.error('InValid Id!');
    }
  }

}
